/**
 * Returns true if the time component of the date is 00:00
 * @param date
 */
export function isMidnightMinute(date: Date): boolean {
  if (!date) {
    return false;
  }
  return date.getMinutes() == 0 && date.getHours() == 0;
}

export function addHours(date: string | Date, hours: number): Date {
  return new Date(new Date(date).getTime() + hours * 3600000);
}

/**
 * Rounds a date up to the next whole hour, clearing minutes, seconds and milliseconds. A date that
 * already sits exactly on the hour is returned unchanged.
 */
export function roundUpToNextHour(date: string | Date): Date {
  const result = new Date(date);
  const isOnTheHour =
    result.getMinutes() === 0 && result.getSeconds() === 0 && result.getMilliseconds() === 0;

  result.setMinutes(0, 0, 0);

  if (!isOnTheHour) {
    result.setHours(result.getHours() + 1);
  }

  return result;
}

export function isDateToday(d: Date | string | null): boolean {
  if (!d) return false;
  const today = new Date();

  const date = typeof d === 'string' ? new Date(d) : d;

  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  );
}
